import React from 'react';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import {
  DetailPanel,
  PanelSideWrapper,
  PanelResizeHandle,
  PanelCollapsedRail,
  PanelCollapsedTabAnchor,
  PanelCollapsedTab,
  PanelCollapsedTabText,
  PanelCollapsedBadge,
  PanelEdgeTabAnchor,
  PanelEdgeTab,
  PanelEdgeCollapseButton,
} from './PrivateLessonStyled';
import { usePanelResize } from './hooks/usePanelResize';

/**
 * 월/주 공용 우측 상세 패널 셸
 * - 접힘: 우측 가장자리 세로 중앙 탭(«·상세·건수 배지) 클릭으로 펼침
 * - 펼침: 좌측 엣지 중앙 핸들 탭(») 클릭으로 접기, 좌측 엣지 전체 드래그로 가로폭 조절
 */
const PrivateLessonPanelShell = ({ width, collapsed, onToggleCollapse, onWidthChange, count, maxHeight, children }) => {
  const handleResizeStart = usePanelResize({ width, onWidthChange });

  if (collapsed) {
    return (
      <PanelCollapsedRail type="button" onClick={onToggleCollapse} aria-label="상세 패널 펼치기">
        <PanelCollapsedTabAnchor>
          <PanelCollapsedTab className="collapsed-tab">
            <KeyboardDoubleArrowLeftIcon />
            <PanelCollapsedTabText>상세</PanelCollapsedTabText>
            {typeof count === 'number' && <PanelCollapsedBadge>{count}</PanelCollapsedBadge>}
          </PanelCollapsedTab>
        </PanelCollapsedTabAnchor>
      </PanelCollapsedRail>
    );
  }

  return (
    <PanelSideWrapper>
      <PanelResizeHandle onMouseDown={handleResizeStart} aria-label="패널 폭 조절" />
      <PanelEdgeTabAnchor>
        <PanelEdgeTab>
          <PanelEdgeCollapseButton type="button" onClick={onToggleCollapse} aria-label="상세 패널 접기">
            <KeyboardDoubleArrowRightIcon />
          </PanelEdgeCollapseButton>
        </PanelEdgeTab>
      </PanelEdgeTabAnchor>
      <DetailPanel panelWidth={width} panelMaxHeight={maxHeight}>
        {children}
      </DetailPanel>
    </PanelSideWrapper>
  );
};

export default PrivateLessonPanelShell;
